import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';

import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { SigninComponent } from './auth/signin/signin.component';
import { RegisterComponent } from './auth/register/register.component';
import { ForgetPasswordComponent } from './auth/forget-password/forget-password.component';
import { AuthComponent } from './auth/auth.component';
import { DashboardComponent } from './dashboard/dashboard.component';
import { AuthNavbarComponent } from './shared/auth-navbar/auth-navbar.component';
import { AuthFooterComponent } from './shared/auth-footer/auth-footer.component';
import { DashboardNavbarComponent } from './shared/dashboard-navbar/dashboard-navbar.component';
import { DashboardFooterComponent } from './shared/dashboard-footer/dashboard-footer.component';
import { FormsModule } from '@angular/forms';
import { ResetEmailSentComponent } from './auth/reset-email-sent/reset-email-sent.component';
import { ResetPasswordFormComponent } from './auth/reset-password-form/reset-password-form.component';
import { ResetPasswordSuccessfulComponent } from './auth/reset-password-successful/reset-password-successful.component';
import { HttpClientModule, HTTP_INTERCEPTORS } from '@angular/common/http';
import { VerifyEmailComponent } from './dashboard/verify-email/verify-email.component';
import { TokenInterceptorService } from './services/token-interceptor.service';
import { ContactListComponent } from './dashboard/contact-list/contact-list.component';
import { AccountComponent } from './dashboard/account/account.component';
import { SidebarComponent } from './shared/sidebar/sidebar.component';
import { HomeComponent } from './dashboard/home/home.component';
import { VerifyPhonenumberComponent } from './dashboard/verify-phonenumber/verify-phonenumber.component';
import { DocumentComponent } from './dashboard/document/document.component';
import { VerifyDocumentComponent } from './dashboard/verify-document/verify-document.component';
import { ContactCardComponent } from './shared/contact-card/contact-card.component';
import { CreateContactComponent } from './dashboard/create-contact/create-contact.component'
import {DialogModule} from 'primeng/dialog';
import {ToastModule} from 'primeng/toast';
import {BrowserAnimationsModule} from '@angular/platform-browser/animations';
import { HomepageComponent } from './homepage/homepage.component';
import { SendMoneyComponent } from './dashboard/send-money/send-money.component';
import { Step1Component } from './dashboard/send-money/step1/step1.component';
import { Step2Component } from './dashboard/send-money/step2/step2.component';
import { MessageService } from 'primeng/api';
import { SettingsComponent } from './dashboard/settings/settings.component';
import { Setting1Component } from './dashboard/settings/setting1/setting1.component';
import { Step3Component } from './dashboard/send-money/step3/step3.component';
import { PurposeComponent } from './dashboard/send-money//purpose/purpose.component';
import { Step4Component } from './dashboard/send-money/step4/step4.component';
import { Step5Component } from './dashboard/send-money/step5/step5.component';
import { PaymentMethodComponent } from './dashboard/payment-method/payment-method.component';
import { CaDocumentComponent } from './dashboard/ca-document/ca-document.component';
import { ManagePaymentMethodsComponent } from './dashboard/manage-payment-methods/manage-payment-methods.component';
import {CalendarModule} from 'primeng/calendar';
import { LoaderComponent } from './shared/loader/loader.component';
import { DcintracSendSuccessfulComponent } from './dashboard/dcintrac-send-successful/dcintrac-send-successful.component';
import { ReferFriendComponent } from './dashboard/refer-friend/refer-friend.component';
import { AddBillerComponent } from './dashboard/add-biller/add-biller.component';
import { Biller1Component } from './dashboard/pay-bill/biller1/biller1.component';
import { PayBillComponent } from './dashboard/pay-bill/pay-bill.component';
import { Biller2Component } from './dashboard/pay-bill/biller2/biller2.component';
import { Biller3Component } from './dashboard/pay-bill/biller3/biller3.component';
import { Biller4Component } from './dashboard/pay-bill/biller4/biller4.component';
import { RequestMoneyComponent } from './dashboard/request-money/request-money.component';
import { RequestStep1Component } from './dashboard/request-money/request-step1/request-step1.component';
import { RequestStep2Component } from './dashboard/request-money/request-step2/request-step2.component';
import { RequestStep3Component } from './dashboard/request-money/request-step3/request-step3.component';
import { RequestStep4Component } from './dashboard/request-money/request-step4/request-step4.component';
import { AddRequestMethodComponent } from './dashboard/request-money/add-request-method/add-request-method.component';
import { Biller5Component } from './dashboard/pay-bill/biller5/biller5.component';
import { TermsAndConditionsComponent } from './terms-and-conditions/terms-and-conditions.component';
import { PayBillHomeComponent } from './homepage/pay-bill-home/pay-bill-home.component';
import { AboutHomeComponent } from './homepage/about-home/about-home.component';
import { ProfileComponent } from './dashboard/profile/profile.component';
import { FaqComponent } from './faq/faq.component';
import { HomeFooterComponent } from './shared/home-footer/home-footer.component';
import { InAppBrowser } from '@ionic-native/in-app-browser/ngx';
import { RequestRecipientAddFormComponent } from './dashboard/request-recipient-add-form/request-recipient-add-form.component';
import { CadToInrComponent } from './homepage/cad-to-inr/cad-to-inr.component';
import { CadToNgnComponent } from './homepage/cad-to-ngn/cad-to-ngn.component';
import { CadToKesComponent } from './homepage/cad-to-kes/cad-to-kes.component';
import { CadToGhsComponent } from './homepage/cad-to-ghs/cad-to-ghs.component';
import { CadToXofComponent } from './homepage/cad-to-xof/cad-to-xof.component';
import { CadToPhpComponent } from './homepage/cad-to-php/cad-to-php.component';
import { CadToZarComponent } from './homepage/cad-to-zar/cad-to-zar.component';
import { UsdToInrComponent } from './homepage/usd-to-inr/usd-to-inr.component';
import { UsdToNgnComponent } from './homepage/usd-to-ngn/usd-to-ngn.component';
import { UsdToKesComponent } from './homepage/usd-to-kes/usd-to-kes.component';
import {ConfirmDialogModule} from 'primeng/confirmdialog';
import { ConfirmationService } from 'primeng/api';
import { UsdToGhsComponent } from './homepage/usd-to-ghs/usd-to-ghs.component';
import { ServiceWorkerModule } from '@angular/service-worker';
import { environment } from '../environments/environment';
import { Facebook } from '@ionic-native/facebook/ngx';
import { AngularFireModule } from '@angular/fire';
import { AngularFireAuthModule } from '@angular/fire/auth';
import { AngularFirestoreModule } from '@angular/fire/firestore';
import { GooglePlus } from '@ionic-native/google-plus/ngx';
import { QrCodeModule } from 'ng-qrcode';
import { PaymentSuccessQrComponent } from './dashboard/payment-success-qr/payment-success-qr.component';
import { PaymentSourceBillerSuccessComponent } from './dashboard/pay-bill/payment-source-biller-success/payment-source-biller-success.component';
import { CadToGbpComponent } from './homepage/cad-to-gbp/cad-to-gbp.component';
import { CadToEurComponent } from './homepage/cad-to-eur/cad-to-eur.component';
import { AngularFireAnalyticsModule } from '@angular/fire/analytics';
import { UpgradeTierComponent } from './dashboard/upgrade-tier/upgrade-tier.component';
import { AgmCoreModule } from '@agm/core';
import { CustomLocationsComponent } from './custom-locations/custom-locations.component';
import { Step6Component } from './dashboard/send-money/step6/step6.component';
import { CeloSendSuccessfulComponent } from './dashboard/celo-send-successful/celo-send-successful.component';
@NgModule({
  declarations: [
    AppComponent,
    SigninComponent,
    RegisterComponent,
    ForgetPasswordComponent,
    AuthComponent,
    DashboardComponent,
    AuthNavbarComponent,
    AuthFooterComponent,
    DashboardNavbarComponent,
    DashboardFooterComponent,
    ResetEmailSentComponent,
    ResetPasswordFormComponent,
    ResetPasswordSuccessfulComponent,
    VerifyEmailComponent,
    ContactListComponent,
    AccountComponent,
    SidebarComponent,
    HomeComponent,
    VerifyPhonenumberComponent,
    DocumentComponent,
    VerifyDocumentComponent,
    ContactCardComponent,
    CreateContactComponent,
    HomepageComponent,
    SendMoneyComponent,
    Step1Component,
    Step2Component,
    SettingsComponent,
    Setting1Component,
    Step3Component,
    PurposeComponent,
    Step4Component,
    Step5Component,
    PaymentMethodComponent,
    CaDocumentComponent,
    ManagePaymentMethodsComponent,
    LoaderComponent,
    DcintracSendSuccessfulComponent,
    ReferFriendComponent,
    AddBillerComponent,
    PayBillComponent,
    Biller1Component,
    Biller2Component,
    Biller3Component,
    Biller4Component,
    RequestMoneyComponent,
    RequestStep1Component,
    RequestStep2Component,
    RequestStep3Component,
    RequestStep4Component,
    AddRequestMethodComponent,
    Biller5Component,
    TermsAndConditionsComponent,
    PayBillHomeComponent,
    AboutHomeComponent,
    ProfileComponent,
    FaqComponent,
    HomeFooterComponent,
    RequestRecipientAddFormComponent,
    CadToInrComponent,
    CadToNgnComponent,
    CadToKesComponent,
    CadToGhsComponent,
    CadToXofComponent,
    CadToPhpComponent,
    CadToZarComponent,
    UsdToInrComponent,
    UsdToNgnComponent,
    UsdToKesComponent,
    UsdToGhsComponent,
    PaymentSuccessQrComponent,
    PaymentSourceBillerSuccessComponent,
    CadToGbpComponent,
    CadToEurComponent,
    UpgradeTierComponent,
    CustomLocationsComponent,
    Step6Component,
    CeloSendSuccessfulComponent,
    
  ],
  imports: [
    BrowserModule,
    AppRoutingModule,
    FormsModule,
    HttpClientModule,
    DialogModule,
    BrowserAnimationsModule,
    ToastModule,
    CalendarModule,
    ConfirmDialogModule,
    ServiceWorkerModule.register('ngsw-worker.js', { enabled:environment.production }),
    AngularFireModule.initializeApp(environment.firebaseConfig),
    AngularFireAuthModule,
    AngularFirestoreModule,
    AngularFireAnalyticsModule,
    QrCodeModule,
    AgmCoreModule.forRoot({
      apiKey: 'AIzaSyDujZ89H7IWfb0EsqQz_MG9oG28QuClDKM',
      libraries: ['places']
    })

  ],
  providers: [
    {
      provide:HTTP_INTERCEPTORS,
      useClass:TokenInterceptorService,
      multi:true
    },
    MessageService,
    ConfirmationService,
    InAppBrowser,
    Facebook,
    GooglePlus
  ],
  bootstrap: [AppComponent]
})
export class AppModule { }
